import { useState } from 'react';
import { t, Trans } from '@lingui/macro';
import { useSearchParams } from 'react-router-dom';

import { UiCard } from '../../components/ui/ui-card/ui-card';
import { BuyTicket } from '../../domains/buy-ticket/buy-ticket';
import { MainSideMenu } from '../../features/main-side-menu/main-side-menu';
import { useLocal } from '../../lib/local/use-local';

import styles from './buy-tickets.module.css';

type Steps =
  | 'addPassengers'
  | 'selectSeats'
  | 'applyAgreement'
  | 'confirmPay'
  | 'redirectToBank';

const getStepsTitle = (step: Steps): string => {
  switch (step) {
    case 'addPassengers':
      return t`Добавление пассажиров`;
    case 'selectSeats':
      return t`Выбор мест`;
    case 'applyAgreement':
      return t`Условия возврата`;
    case 'confirmPay':
      return t`Подтверждение платежа`;
    case 'redirectToBank':
      return t`Переход к банку`;
    default:
      return t`Пустой заголовок`;
  }
};

export const BuyTicketsPage = () => {
  useLocal();
  const [searchParams] = useSearchParams();
  const [step, setStep] = useState<Steps>('addPassengers');

  const tripid = searchParams.get('tripid');
  const startStation = searchParams.get('startStation');
  const endStation = searchParams.get('endStation');

  if (!tripid || !startStation || !endStation)
    return (
      <div className={styles.container}>
        <header className={styles.header}>
          <h1 className={styles.headerTitle}>{getStepsTitle(step)}</h1>
          <MainSideMenu />
        </header>
        <main className={styles.main}>
          <UiCard>
            <Trans>
              Неверные параметры в строке адреса. Начните поиск билетов заново
            </Trans>
          </UiCard>
        </main>
      </div>
    );

  return (
    <div className={styles.container}>
      <header className={styles.header}>
        <h1 className={styles.headerTitle}>{getStepsTitle(step)}</h1>
        <MainSideMenu />
      </header>
      <main className={styles.main}>
        <BuyTicket
          tripid={tripid}
          startStationId={startStation}
          endStationId={endStation}
          onChangeStep={(step) => setStep(step)}
        />
      </main>
    </div>
  );
};
